import Big from "big.js";

// 默认价格保留位数
export const DEFAULT_PRICE_DECIMAL_PLACES = 4;

const normalizeDecimalPlaces = (value) => {
  const decimalPlaces = Number(value);
  return Number.isInteger(decimalPlaces) && decimalPlaces >= 0
    ? decimalPlaces
    : DEFAULT_PRICE_DECIMAL_PLACES;
};

/**
 * 将价格四舍五入到指定精度，并移除小数末尾无意义的 0。
 *
 * 返回字符串用于页面展示，或用于规范化请求参数副本。接口原始数据和
 * 表单编辑值不应提前覆盖，避免展示格式影响后续计算及用户继续编辑。
 *
 * @param {number|string|null|undefined} value 待处理的价格
 * @param {number} maxDecimalPlaces 小数点后最多保留位数，默认 4 位
 * @returns {string} 规范化价格；非数字文本保持原样
 */
export function formatPrice(
  value,
  maxDecimalPlaces = DEFAULT_PRICE_DECIMAL_PLACES,
) {
  if (value === null || value === undefined) return "";

  const source = typeof value === "string" ? value.trim() : String(value);
  if (!source) return "";

  const decimalPlaces = normalizeDecimalPlaces(maxDecimalPlaces);

  try {
    const rounded = new Big(source).round(decimalPlaces, Big.roundHalfUp);
    if (rounded.eq(0)) return "0";
    return rounded
      .toFixed(decimalPlaces)
      .replace(/(?:\.0+|(\.\d*?[1-9])0+)$/, "$1");
  } catch (_error) {
    return source;
  }
}
